module.exports = __webpack_public_path__ + "static/media/Bergmite_gaussian2.00be36d8.png";